import { Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SelectItem, SelectItemModalComponent } from '@modals';
import { CompanySelectionService } from './company-selection.service';

@Component({
  selector: 'mbp-company-selection-modal',
  templateUrl: './company-selection-modal.component.html',
  styleUrl: './company-selection-modal.component.scss',
  imports: [TranslateModule, SelectItemModalComponent]
})
export class CompanySelectionModalComponent {
  private readonly companySelectionService = inject(CompanySelectionService);

  protected readonly request = this.companySelectionService.activeRequest;

  private pendingSelection: SelectItem | null = null;

  protected readonly loadCompanies = async (): Promise<SelectItem[]> => this.request()?.companies ?? [];

  protected readonly selectCompany = async (item: SelectItem): Promise<void> => {
    this.pendingSelection = item;
  };

  protected onClose(): void {
    const selection = this.pendingSelection;
    this.pendingSelection = null;
    this.companySelectionService.complete(selection);
  }
}
